export const SVGOverlayTextStyle: React.CSSProperties = { fontSize: '17px' };
export const SVGOverlayTextFill = 'white';

export const orangeOptions = { color: 'orange' };

export const PROCENT_PASKA_X_1 = 0.0263;
export const PROCENT_PASKA_X_2 = 0.0526;
export const PROCENT_PASKA_X_3 = 0.0789;

export const opisy = [
    {
        "id": "1",
        "opis": "LUBELSKIE",
        "regionId": "1",
        "krainaId": "1",
        "obszarId": "0",
        "mapaOpisWspGoraSzerokosc": "51.90190",
        "mapaOpisWspDolSzerokosc": "51.70190",
        "mapaOpisWspLewaDlugosc": "24.98178",
        "mapaOpisWspPrawaDlugosc": "27.10000",
        "mapaOpisLiniaStartWspSzerokosc": "51.60190",                    //koniec szerokość
        "mapaOpisLiniaStartWspDlugosc": "24.98178",                      //koniec długość 
        "mapaOpisLiniaStopWspSzerokosc": "51.24770",                     //początek szerokość
        "mapaOpisLiniaStopWspDlugosc": "22.56793",                       //początek długość
        "mapaOpisFontKolor": "white",
        "mapaOpisTloKolor": "green",
        "mapaOpisFontSize1920": "15",
        "mapaOpisFontSize1600": "13",
        "mapaOpisFontSize1280": "8",
        "mapaOpisFontSizeMobile": "6",
        "mapaOpisKomponentNr": "0"
    },

    {
        "id": "2",
        "opis": "MAŁOPOLSKIE",
        "regionId": "1",
        "krainaId": "2",
        "obszarId": "0",
        "mapaOpisWspGoraSzerokosc": "48.934455",
        "mapaOpisWspDolSzerokosc": "48.734455",
        "mapaOpisWspLewaDlugosc": "20.2368164",
        "mapaOpisWspPrawaDlugosc": "22.2368164",
        "mapaOpisLiniaStartWspSzerokosc": "48.934455",
        "mapaOpisLiniaStartWspDlugosc": "21.2368164",
        "mapaOpisLiniaStopWspSzerokosc": "50.06171",
        "mapaOpisLiniaStopWspDlugosc": "19.93731",
        "mapaOpisFontKolor": "white",
        "mapaOpisTloKolor": "green",
        "mapaOpisFontSize1920": "15",
        "mapaOpisFontSize1600": "13",
        "mapaOpisFontSize1280": "8",
        "mapaOpisFontSizeMobile": "6",
        "mapaOpisKomponentNr": "0"
    },

    {
        "id": "3",
        "opis": "PODKARPACKIE",
        "regionId": "1",
        "krainaId": "3",
        "obszarId": "0",
        "mapaOpisWspGoraSzerokosc": "49.49647",
        "mapaOpisWspDolSzerokosc": "49.29647",
        "mapaOpisWspLewaDlugosc": "23.46679",
        "mapaOpisWspPrawaDlugosc": "25.66679",
        "mapaOpisLiniaStartWspSzerokosc": "49.19647",
        "mapaOpisLiniaStartWspDlugosc": "23.46679",
        "mapaOpisLiniaStopWspSzerokosc": "50.03745",
        "mapaOpisLiniaStopWspDlugosc": "22.00491",
        "mapaOpisFontKolor": "white",
        "mapaOpisTloKolor": "green",
        "mapaOpisFontSize1920": "15",
        "mapaOpisFontSize1600": "13",
        "mapaOpisFontSize1280": "8",
        "mapaOpisFontSizeMobile": "6",
        "mapaOpisKomponentNr": "0"
    },

    {
        "id": "4",
        "opis": "MAZOWIECKIE",
        "regionId": "1",
        "krainaId": "4",
        "obszarId": "0",
        "mapaOpisWspGoraSzerokosc": "53.12040",
        "mapaOpisWspDolSzerokosc": "52.92040",   //- 0.2
        "mapaOpisWspLewaDlugosc": "24.07202",    
        "mapaOpisWspPrawaDlugosc": "26.27202",   //+2.2
        "mapaOpisLiniaStartWspSzerokosc": "52.82040",
        "mapaOpisLiniaStartWspDlugosc": "24.07202",
        "mapaOpisLiniaStopWspSzerokosc": "52.23024",
        "mapaOpisLiniaStopWspDlugosc": "21.00714",
        "mapaOpisFontKolor": "white",
        "mapaOpisTloKolor": "green",
        "mapaOpisFontSize1920": "15",
        "mapaOpisFontSize1600": "13",
        "mapaOpisFontSize1280": "8",
        "mapaOpisFontSizeMobile": "6",
        "mapaOpisKomponentNr": "0"
    },

    {
        "id": "5",
        "opis": "PODLASKIE",
        "regionId": "1",
        "krainaId": "3",
        "obszarId": "0",
        "mapaOpisWspGoraSzerokosc": "54.32659",
        "mapaOpisWspDolSzerokosc": "54.12659",
        "mapaOpisWspLewaDlugosc": "24.84882",
        "mapaOpisWspPrawaDlugosc": "27.04882",
        "mapaOpisLiniaStartWspSzerokosc": "54.02659",
        "mapaOpisLiniaStartWspDlugosc": "24.84882",
        "mapaOpisLiniaStopWspSzerokosc": "53.13232",
        "mapaOpisLiniaStopWspDlugosc": "23.15940",
        "mapaOpisFontKolor": "white",
        "mapaOpisTloKolor": "green",
        "mapaOpisFontSize1920": "15",
        "mapaOpisFontSize1600": "13",
        "mapaOpisFontSize1280": "8",
        "mapaOpisFontSizeMobile": "6",
        "mapaOpisKomponentNr": "0"
    }, 

    { 
        "id": "6",
        "opis": "WARMIŃSKO-MAZURSKIE",
        "regionId": "1",
        "krainaId": "4",
        "obszarId": "0",
        "mapaOpisWspGoraSzerokosc": "55.32711",
        "mapaOpisWspDolSzerokosc": "55.12711",   //- 0.2
        "mapaOpisWspLewaDlugosc": "21.72021",    
        "mapaOpisWspPrawaDlugosc": "24.42021",   //+2.2
        "mapaOpisLiniaStartWspSzerokosc": "54.72711",
        "mapaOpisLiniaStartWspDlugosc": "22.92021",
        "mapaOpisLiniaStopWspSzerokosc": "53.77662",
        "mapaOpisLiniaStopWspDlugosc": "20.47618",
        "mapaOpisFontKolor": "white",
        "mapaOpisTloKolor": "green",
        "mapaOpisFontSize1920": "15",
        "mapaOpisFontSize1600": "13",
        "mapaOpisFontSize1280": "8",
        "mapaOpisFontSizeMobile": "6",
        "mapaOpisKomponentNr": "0"
    }, 

    { 
        "id": "7",
        "opis": "POMORSKIE",
        "regionId": "1",
        "krainaId": "4",
        "obszarId": "0",
        "mapaOpisWspGoraSzerokosc": "55.63213",
        "mapaOpisWspDolSzerokosc": "55.43213",   //- 0.2
        "mapaOpisWspLewaDlugosc": "19.01020",    
        "mapaOpisWspPrawaDlugosc": "21.21020",   //+2.2
        "mapaOpisLiniaStartWspSzerokosc": "55.03213",
        "mapaOpisLiniaStartWspDlugosc": "20.01020",
        "mapaOpisLiniaStopWspSzerokosc": "54.34834",
        "mapaOpisLiniaStopWspDlugosc": "18.65374",
        "mapaOpisFontKolor": "white",
        "mapaOpisTloKolor": "green",
        "mapaOpisFontSize1920": "15",
        "mapaOpisFontSize1600": "13",
        "mapaOpisFontSize1280": "8",
        "mapaOpisFontSizeMobile": "6",
        "mapaOpisKomponentNr": "0"
    }, 

    { 
        "id": "8",
        "opis": "KUJAWSKO-POMORSKIE",
        "regionId": "1",
        "krainaId": "4",
        "obszarId": "0",
        "mapaOpisWspGoraSzerokosc": "55.48118",
        "mapaOpisWspDolSzerokosc": "55.28118",   //- 0.2
        "mapaOpisWspLewaDlugosc": "15.80234",    
        "mapaOpisWspPrawaDlugosc": "18.40234",   //+2.2
        "mapaOpisLiniaStartWspSzerokosc": "54.88118",
        "mapaOpisLiniaStartWspDlugosc": "16.90234",
        "mapaOpisLiniaStopWspSzerokosc": "53.12187",
        "mapaOpisLiniaStopWspDlugosc": "18.00043",
        "mapaOpisFontKolor": "white",
        "mapaOpisTloKolor": "green",
        "mapaOpisFontSize1920": "15",
        "mapaOpisFontSize1600": "13",
        "mapaOpisFontSize1280": "8",
        "mapaOpisFontSizeMobile": "6",
        "mapaOpisKomponentNr": "0"
    }, 

    { 
        "id": "9",
        "opis": "ZACHODNIO-POMORSKIE",
        "regionId": "1",
        "krainaId": "4",
        "obszarId": "0",
        "mapaOpisWspGoraSzerokosc": "54.88168",
        "mapaOpisWspDolSzerokosc": "54.68168",   //- 0.2
        "mapaOpisWspLewaDlugosc": "12.28247",    
        "mapaOpisWspPrawaDlugosc": "14.98247",   //+2.2
        "mapaOpisLiniaStartWspSzerokosc": "54.28168",
        "mapaOpisLiniaStartWspDlugosc": "13.38247",
        "mapaOpisLiniaStopWspSzerokosc": "53.43271",
        "mapaOpisLiniaStopWspDlugosc": "14.54806",
        "mapaOpisFontKolor": "white",
        "mapaOpisTloKolor": "green",
        "mapaOpisFontSize1920": "15",
        "mapaOpisFontSize1600": "13",
        "mapaOpisFontSize1280": "8",
        "mapaOpisFontSizeMobile": "6",
        "mapaOpisKomponentNr": "0"
    }, 

    { 
        "id": "10",
        "opis": "WIELKOPOLSKIE", 
        "regionId": "1",
        "krainaId": "4",
        "obszarId": "0",
        "mapaOpisWspGoraSzerokosc": "53.32877", 
        "mapaOpisWspDolSzerokosc": "53.12877",   //- 0.2
        "mapaOpisWspLewaDlugosc": "11.80170",    
        "mapaOpisWspPrawaDlugosc": "14.00170",   //+2.2
        "mapaOpisLiniaStartWspSzerokosc": "53.02877",
        "mapaOpisLiniaStartWspDlugosc": "14.00170",
        "mapaOpisLiniaStopWspSzerokosc": "52.40819",
        "mapaOpisLiniaStopWspDlugosc": "16.9335",
        "mapaOpisFontKolor": "white",
        "mapaOpisTloKolor": "green",
        "mapaOpisFontSize1920": "15",
        "mapaOpisFontSize1600": "13",
        "mapaOpisFontSize1280": "8",
        "mapaOpisFontSizeMobile": "6",
        "mapaOpisKomponentNr": "0"
    }, 

    { 
        "id": "11",
        "opis": "LUBUSKIE", 
        "regionId": "1",
        "krainaId": "4",
        "obszarId": "0",
        "mapaOpisWspGoraSzerokosc": "52.43071",   
        "mapaOpisWspDolSzerokosc": "52.23071",   //- 0.2
        "mapaOpisWspLewaDlugosc": "10.76936",    
        "mapaOpisWspPrawaDlugosc": "12.96936",   //+2.2
        "mapaOpisLiniaStartWspSzerokosc": "52.13071",
        "mapaOpisLiniaStartWspDlugosc": "12.96936",
        "mapaOpisLiniaStopWspSzerokosc": "51.93829", 	
        "mapaOpisLiniaStopWspDlugosc": "15.50530",
        "mapaOpisFontKolor": "white",
        "mapaOpisTloKolor": "green",
        "mapaOpisFontSize1920": "15",
        "mapaOpisFontSize1600": "13",
        "mapaOpisFontSize1280": "8",
        "mapaOpisFontSizeMobile": "6",
        "mapaOpisKomponentNr": "0"
    }, 

    { 
        "id": "12",
        "opis": "DOLNOŚLĄSKIE", 
        "regionId": "1",
        "krainaId": "4",
        "obszarId": "0",
        "mapaOpisWspGoraSzerokosc": "50.51740",   
        "mapaOpisWspDolSzerokosc": "50.31740",   //- 0.2
        "mapaOpisWspLewaDlugosc": "12.00444",    
        "mapaOpisWspPrawaDlugosc": "14.20444",   //+2.2
        "mapaOpisLiniaStartWspSzerokosc": "50.21740",
        "mapaOpisLiniaStartWspDlugosc": "14.20444",
        "mapaOpisLiniaStopWspSzerokosc": "51.11002", 	
        "mapaOpisLiniaStopWspDlugosc": "17.03191",
        "mapaOpisFontKolor": "white",
        "mapaOpisTloKolor": "green",
        "mapaOpisFontSize1920": "15",
        "mapaOpisFontSize1600": "13",
        "mapaOpisFontSize1280": "8",
        "mapaOpisFontSizeMobile": "6",
        "mapaOpisKomponentNr": "0"
    }, 

    { 
        "id": "13",
        "opis": "ŁÓDZKIE", 
        "regionId": "1",
        "krainaId": "4",
        "obszarId": "0",
        "mapaOpisWspGoraSzerokosc": "51.57275",    	
        "mapaOpisWspDolSzerokosc": "51.37275",   //- 0.2
        "mapaOpisWspLewaDlugosc": "12.51245",    
        "mapaOpisWspPrawaDlugosc": "14.71245",   //+2.2
        "mapaOpisLiniaStartWspSzerokosc": "51.27275",
        "mapaOpisLiniaStartWspDlugosc": "14.71245",
        "mapaOpisLiniaStopWspSzerokosc": "51.77846", 	 
        "mapaOpisLiniaStopWspDlugosc": "19.45189",
        "mapaOpisFontKolor": "white",
        "mapaOpisTloKolor": "green",
        "mapaOpisFontSize1920": "15",
        "mapaOpisFontSize1600": "13",
        "mapaOpisFontSize1280": "8",
        "mapaOpisFontSizeMobile": "6",
        "mapaOpisKomponentNr": "0"
    }, 

    { 
        "id": "14",
        "opis": "ŚLĄSKIE", 
        "regionId": "1",
        "krainaId": "4",
        "obszarId": "0",
        "mapaOpisWspGoraSzerokosc": "49.06780",   
        "mapaOpisWspDolSzerokosc": "48.86780",   //- 0.2
        "mapaOpisWspLewaDlugosc": "17.13530",    
        "mapaOpisWspPrawaDlugosc": "19.33530",   //+2.2
        "mapaOpisLiniaStartWspSzerokosc": "49.06780",
        "mapaOpisLiniaStartWspDlugosc": "18.33530",
        "mapaOpisLiniaStopWspSzerokosc": "50.25952",
        "mapaOpisLiniaStopWspDlugosc": "19.02186",
        "mapaOpisFontKolor": "white",
        "mapaOpisTloKolor": "green",
        "mapaOpisFontSize1920": "15",
        "mapaOpisFontSize1600": "13",
        "mapaOpisFontSize1280": "8",
        "mapaOpisFontSizeMobile": "6",
        "mapaOpisKomponentNr": "0"
    }, 
    { 
        "id": "15",
        "opis": "OPOLSKIE", 
        "regionId": "1",
        "krainaId": "4",
        "obszarId": "0",
        "mapaOpisWspGoraSzerokosc": "49.96888",    
        "mapaOpisWspDolSzerokosc": "49.76888",   //- 0.2
        "mapaOpisWspLewaDlugosc": "15.09833",    
        "mapaOpisWspPrawaDlugosc": "17.29833",   //+2.2
        "mapaOpisLiniaStartWspSzerokosc": "49.96888",
        "mapaOpisLiniaStartWspDlugosc": "16.19833",
        "mapaOpisLiniaStopWspSzerokosc": "50.66832", 
        "mapaOpisLiniaStopWspDlugosc": "17.92246",
        "mapaOpisFontKolor": "white",
        "mapaOpisTloKolor": "green",
        "mapaOpisFontSize1920": "15",
        "mapaOpisFontSize1600": "13",
        "mapaOpisFontSize1280": "8",
        "mapaOpisFontSizeMobile": "6",
        "mapaOpisKomponentNr": "0"
    }, 
    { 
        "id": "16",
        "opis": "ŚWIĘTOKRZYSKIE", 
        "regionId": "1",
        "krainaId": "4",
        "obszarId": "0",
        "mapaOpisWspGoraSzerokosc": "50.72040",
        "mapaOpisWspDolSzerokosc": "50.52040",   //- 0.2
        "mapaOpisWspLewaDlugosc": "24.27202",    
        "mapaOpisWspPrawaDlugosc": "26.47202",   //+2.2
        "mapaOpisLiniaStartWspSzerokosc": "50.42040",
        "mapaOpisLiniaStartWspDlugosc": "24.27202",
        "mapaOpisLiniaStopWspSzerokosc": "50.86944", 
        "mapaOpisLiniaStopWspDlugosc": "20.62922",
        "mapaOpisFontKolor": "white",
        "mapaOpisTloKolor": "green",
        "mapaOpisFontSize1920": "15",
        "mapaOpisFontSize1600": "13",
        "mapaOpisFontSize1280": "8",
        "mapaOpisFontSizeMobile": "6",
        "mapaOpisKomponentNr": "0"
    }, 




   
]

export const tablicaRegionOpisy = [
    {
        id: '1',
        regionId: '1',
        krainaId: '1',
        obszarId: '0',
        opis: 'WIELKA WODA',
        opisWspGoraSzerokosc: '49.47760', //wspolrzedne prostokata
        opisWspDolSzerokosc: '49.45136',
        opisWspLewaDlugosc: '21.82594',
        opisWspPrawaDlugosc: '22.07378',
        liniaStartWspSzerokosc: '49.42964', //wspolrzedne srodka startu lini
        liniaStartWspDlugosc: '21.98249',
        liniaStopWspSzerokosc: '49.37559', //wspolrzedne srodka stopu lini
        liniaStoptWspDlugosc: '22.39688',
        // fontSize: 10,
        // fontKolor: 'white',
        // tlokolor: 'orange',
        // komponentNr: 1,
        // obszarId: '12',        
    },
    {
        id: '2',
        regionId: '1',
        krainaId: '5',
        obszarId: '0',
        opis: 'DZIKI WSCHÓD',
        opisWspGoraSzerokosc: '49.43516',
        opisWspDolSzerokosc: '49.40892',
        opisWspLewaDlugosc: '22.69857',
        opisWspPrawaDlugosc: '22.91615',
        liniaStartWspSzerokosc: '49.24764',
        liniaStartWspDlugosc: '21.79775',
        liniaStopWspSzerokosc: '49.27852',
        liniaStoptWspDlugosc: '22.12988',
    },
    {
        id: '3',
        regionId: '1',
        krainaId: '2',
        obszarId: '0',
        opis: 'DZIKI ZACHÓD',
        opisWspGoraSzerokosc: '49.27596',
        opisWspDolSzerokosc: '49.24972',
        opisWspLewaDlugosc: '21.53491',
        opisWspPrawaDlugosc: '21.76312',
        liniaStartWspSzerokosc: '49.40334',
        liniaStartWspDlugosc: '22.80804',
        liniaStopWspSzerokosc: '49.29251',
        liniaStoptWspDlugosc: '22.70096',
    },
    {
        id: '4',
        regionId: '1',
        krainaId: '4',
        obszarId: '0',
        opis: 'POMIĘDZY',
        opisWspGoraSzerokosc: '49.07286',
        opisWspDolSzerokosc: '49.04662',
        opisWspLewaDlugosc: '22.59828',
        opisWspPrawaDlugosc: '22.82649',
        liniaStartWspSzerokosc: '',
        liniaStartWspDlugosc: '',
        liniaStopWspSzerokosc: '',
        liniaStoptWspDlugosc: '',
    },
    {
        id: '5',
        regionId: '1',
        krainaId: '3',
        obszarId: '0',
        opis: 'WYSOKIE GÓRY',
        opisWspGoraSzerokosc: '49.05331',
        opisWspDolSzerokosc: '49.02707',
        opisWspLewaDlugosc: '21.64851',
        opisWspPrawaDlugosc: '21.87254',
        liniaStartWspSzerokosc: '49.03313',
        liniaStartWspDlugosc: '21.92840',
        liniaStopWspSzerokosc: '49.13944',
        liniaStoptWspDlugosc: '22.46603',
    },
];

export const tablicaKrainyOpisy = [
    {
        id: '1',
        regionId: '1',
        krainaId: '1',
        obszarId: '10',
        opis: 'WOŁKOWYJA',
        opisWspGoraSzerokosc: '49.33175', //wspolrzedne prostokata
        opisWspDolSzerokosc: '49.31102',
        opisWspLewaDlugosc: '22.23478',
        opisWspPrawaDlugosc: '22.29087',
        liniaStartWspSzerokosc: '49.31814', //wspolrzedne srodka startu lini
        liniaStartWspDlugosc: '22.29557',
        liniaStopWspSzerokosc: '49.33485', //wspolrzedne srodka stopu lini
        liniaStoptWspDlugosc: '22.40892',
    },
    {
        id: '2',
        regionId: '1',
        krainaId: '1',
        obszarId: '9',
        opis: 'TELEŚNICA',
        opisWspGoraSzerokosc: '49.38059',
        opisWspDolSzerokosc: '49.35986',
        opisWspLewaDlugosc: '22.66236',
        opisWspPrawaDlugosc: '22.68971',
        liniaStartWspSzerokosc: '49.39452',
        liniaStartWspDlugosc: '22.64653',
        liniaStopWspSzerokosc: '49.37790',
        liniaStoptWspDlugosc: '22.54037',
    },
    {
        id: '3',
        regionId: '1',
        krainaId: '5',
        obszarId: '20',
        opis: 'USTRZYKI DOLNE',
        opisWspGoraSzerokosc: '49.46230',
        opisWspDolSzerokosc: '49.45437',
        opisWspLewaDlugosc: '22.75514',
        opisWspPrawaDlugosc: '22.93318',
        liniaStartWspSzerokosc: '49.45196',
        liniaStartWspDlugosc: '22.79770',
        liniaStopWspSzerokosc: '49.43169',
        liniaStoptWspDlugosc: '22.60171',
    },
    {
        id: '4',
        regionId: '1',
        krainaId: '5',
        obszarId: '7',
        opis: 'LUTOWISKA',
        opisWspGoraSzerokosc: '49.36072',
        opisWspDolSzerokosc: '49.35279',
        opisWspLewaDlugosc: '22.89531',
        opisWspPrawaDlugosc: '23.06777',
        liniaStartWspSzerokosc: '49.29355',
        liniaStartWspDlugosc: '22.91562',
        liniaStopWspSzerokosc: '49.25421',
        liniaStoptWspDlugosc: '22.69147',
    },
    {
        id: '5',
        regionId: '1',
        krainaId: '2',
        obszarId: '6',
        opis: 'KOMAŃCZA',
        opisWspGoraSzerokosc: '49.38681',
        opisWspDolSzerokosc: '49.37942',
        opisWspLewaDlugosc: '22.02164',
        opisWspPrawaDlugosc: '22.05951',
        liniaStartWspSzerokosc: '49.37851',
        liniaStartWspDlugosc: '22.04170',
        liniaStopWspSzerokosc: '49.33917',
        liniaStoptWspDlugosc: '22.06687',
    },
    {
        id: '6',
        regionId: '1',
        krainaId: '2',
        obszarId: '17',
        opis: 'BYSTRE',
        opisWspGoraSzerokosc: '49.28717',
        opisWspDolSzerokosc: '49.27978',
        opisWspLewaDlugosc: '22.33861',
        opisWspPrawaDlugosc: '22.36216',
        liniaStartWspSzerokosc: '49.29087',
        liniaStartWspDlugosc: '22.34234',
        liniaStopWspSzerokosc: '49.30765',
        liniaStoptWspDlugosc: '22.27954',
    },
    {
        id: '7',
        regionId: '1',
        krainaId: '4',
        obszarId: '15',
        opis: 'ZATWARNICA',
        opisWspGoraSzerokosc: '49.25359',
        opisWspDolSzerokosc: '49.24939',
        opisWspLewaDlugosc: '22.40950',
        opisWspPrawaDlugosc: '22.43983',
        liniaStartWspSzerokosc: '49.24870',
        liniaStartWspDlugosc: '22.45353',
        liniaStopWspSzerokosc: '49.23343',
        liniaStoptWspDlugosc: '22.55668',
    },
    {
        id: '8',
        regionId: '1',
        krainaId: '4',
        obszarId: '19',
        opis: 'PSZCZELINY',
        opisWspGoraSzerokosc: '49.23803',
        opisWspDolSzerokosc: '49.23383',
        opisWspLewaDlugosc: '22.74597',
        opisWspPrawaDlugosc: '22.79010',
        liniaStartWspSzerokosc: '49.24203',
        liniaStartWspDlugosc: '22.76993',
        liniaStopWspSzerokosc: '49.17472',
        liniaStoptWspDlugosc: '22.69838',
    },
    {
        id: '9',
        regionId: '1',
        krainaId: '3',
        obszarId: '12',
        opis: 'CISNA',
        opisWspGoraSzerokosc: '49.18913',
        opisWspDolSzerokosc: '49.18143',
        opisWspLewaDlugosc: '22.20798',
        opisWspPrawaDlugosc: '22.23440',
        liniaStartWspSzerokosc: '49.19398',
        liniaStartWspDlugosc: '22.23804',
        liniaStopWspSzerokosc: '49.21380',
        liniaStoptWspDlugosc: '22.32182',
    },
    {
        id: '10',
        regionId: '1',
        krainaId: '3',
        obszarId: '13',
        opis: 'USTRZYKI GÓRNE',
        opisWspGoraSzerokosc: '49.18757',
        opisWspDolSzerokosc: '49.17987',
        opisWspLewaDlugosc: '22.70356',
        opisWspPrawaDlugosc: '22.77449',
        liniaStartWspSzerokosc: '49.16899',
        liniaStartWspDlugosc: '22.73385',
        liniaStopWspSzerokosc: '49.10547',
        liniaStoptWspDlugosc: '22.65406',
    },
];

export const tablicaSkrzyzowania = [
    {
        id: '1',
        skrzyzWspSzerokosc: '49.33507',
        skrzyzWspDlugosc: '22.06971',
    },
    {
        id: '2',
        skrzyzWspSzerokosc: '49.20713',
        skrzyzWspDlugosc: '22.32090',
    },
    {
        id: '3',
        skrzyzWspSzerokosc: '49.26332',
        skrzyzWspDlugosc: '22.39963',
    },
    {
        id: '4',
        skrzyzWspSzerokosc: '49.30443',
        skrzyzWspDlugosc: '22.41613',
    },
    {
        id: '5',
        skrzyzWspSzerokosc: '49.32183',
        skrzyzWspDlugosc: '22.66836',
    },
    {
        id: '6',
        skrzyzWspSzerokosc: '49.44183',
        skrzyzWspDlugosc: '22.61144',
    },
    {
        id: '7',
        skrzyzWspSzerokosc: '49.49321',
        skrzyzWspDlugosc: '22.33324',
    },
];